import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@planuze/ui';
import { CheckIcon, LanguagesIcon } from 'lucide-react';
import type { JSX } from 'react';
import { ADMIN_LOCALES } from '../content/locale.js';
import { useAdminLocale } from '../content/locale-provider.js';

/**
 * Troca o idioma do backoffice. Espelha o `ThemeToggle` ao lado — mesma forma de botão-ícone
 * com menu, porque as duas são preferências da mesma natureza e ficam na mesma faixa do header.
 *
 * O nome de cada idioma aparece NO PRÓPRIO idioma: quem procura "English" não reconhece
 * "Inglês", e a lista existe justamente para quem não lê o idioma corrente.
 */
export function LocaleToggle(): JSX.Element {
  const { locale, setLocale, content } = useAdminLocale();
  const copy = content.shell;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={copy.languageLabel}>
          <LanguagesIcon className="size-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {ADMIN_LOCALES.map((opcao) => (
          <DropdownMenuItem
            key={opcao}
            onSelect={() => setLocale(opcao)}
            /* `aria-current` e não só o ícone: o estado atual precisa chegar a quem não vê o
               check. */
            aria-current={opcao === locale ? 'true' : undefined}
            className="flex items-center gap-2"
          >
            <CheckIcon
              className={`size-3.5 shrink-0 ${opcao === locale ? '' : 'invisible'}`}
              aria-hidden="true"
            />
            <span lang={opcao}>{copy.languageNames[opcao]}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
